import React from "react";

import logoIury from "../imgs/iury.png";
import { useAuth } from "../context/AuthContext";
import NavLinkComp from "./micro/NavLinkComp";

const SideBar = ({ logout }) => {
  const { userData, isAdmin } = useAuth();

  return (
    <>
      <div
        className="px-3 sidebar justify-content-between align-items-center"
        expand="lg"
      >
        <div className="d-flex flex-column">
          <div className="d-flex flex-column align-items-center justify-content-around">
            <img
              style={{ height: "50%" }}
              className="logo"
              src={logoIury}
              alt="Logo Iury"
            />
            <h5>Gyn Distribuidora</h5>
          </div>
          <hr />

          <div id="basic-navbar-nav" className="justify-content-between">
            <div className="mr-auto ">
              <NavLinkComp link="/meu-caixa/" title="Caixa do Dia" />
              <NavLinkComp
                link="/clientes-fornecedores"
                title="Clientes/Fornecedores"
              />
              <NavLinkComp link="/produtos/" title="Produtos" />
              <NavLinkComp link="/estoque/" title="Dispositivos" />
              {isAdmin === true || userData.admin === true ? (
                <div className="mt-3">
                  <hr />
                  <p className="mt-3">
                    <i className="bi bi-gear-wide-connected"></i> Administração
                  </p>
                  <hr />
                  <NavLinkComp
                    link={"/relatorios/"}
                    title={"História do IMEI"}
                  />
                  {/* <NavLinkComp
                    link={"relatorios-produtos"}
                    title={"História do Produto"}
                  /> */}
                  <NavLinkComp link="/compras/transactions" title="Compras" />

                  <NavLinkComp link="/vendas/transactions" title="Vendas" />
                  <NavLinkComp
                    link="/devolucao/transactions"
                    title="Devoluções"
                  />

                  <NavLinkComp link="/todos-caixas" title="Caixas" />
                  <NavLinkComp link="/usuarios" title="Usuários" />
                  <NavLinkComp link="/auditoria/" title="Auditoria" />
                </div>
              ) : null}
              <NavLinkComp link="" onClick={logout} title="Sair" />
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center">
          <small>Versão 1.13.4</small>
        </div>
      </div>
    </>
  );
};

export default SideBar;
